export default __webpack_public_path__ + "static/media/Farmer Norfindir's Necklace.21b568b2.jpg";